import React from 'react'

const KeyboardArrowUpIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 -960 960 960" {...props} ><path d="M480-528 296-344l-56-56 240-240 240 240-56 56-184-184Z"/></svg>
  )
}

export default KeyboardArrowUpIcon